import { wrapReducer } from "@client/content/lib/helper";
import { type FailureActionData } from "@client/lib/actions";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type SetModalVisibleActionData, type SubmitBeginActionData } from "./actions";
import { type ContactForm } from "./types";

const reducer = (state: ContactForm.State, action: ReduxAction<any>): ContactForm.State => {
  switch (action.type) {
    case Actions.SetModalVisible: {
      const { isVisible } = action.data as SetModalVisibleActionData;
      return {
        ...state,
        showModal: isVisible
      };
    }
    case Actions.SubmitBegin: {
      return {
        ...state,
        submitError: null,
        status: Status.Saving
      };
    }
    case Actions.SubmitFailure: {
      const { error } = action.data as FailureActionData;
      return {
        ...state,
        showModal: false,
        submitError: error,
        status: Status.Ready
      };
    }
    case Actions.SubmitSuccess: {
      const { showModal } = action.params as SubmitBeginActionData;
      return {
        ...state,
        showModal,
        submitError: null,
        status: showModal ? Status.Ready : Status.Saving
      };
    }
    default:
      return state;
  }
};

export const defaultState: ContactForm.State = {
  id: "",
  showModal: false,
  submitError: null,
  status: Status.Ready
};
export default wrapReducer<ContactForm.State>({ defaultState, reducer, previewState: defaultState });
